import { SUPPORTED_REGIONS } from '../../shared/enums';

const AIR3_BUY_URLS = {
  [SUPPORTED_REGIONS.GB]:
    'https://buy.milacares.com/en-uk/products/mila-air-3-uk',
  [SUPPORTED_REGIONS.AU]:
    'https://buy.milacares.com/en-au/products/mila-air-3-au',
};

const DEFAULT_AIR3_BUY_URL = 'https://buy.milacares.com/products/mila-air-3';

export function getAir3BuyUrl(regional) {
  return AIR3_BUY_URLS[regional] ?? DEFAULT_AIR3_BUY_URL;
}
